import { useEmailContent, LoadboardLabel, LoadboardValue } from "@/components/dataPages/loadboard";
import { Mail, PhoneCall } from "lucide-react";
import { useSelector } from "react-redux";
import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const LoadboardBrokerInfo = ({ load }) => {
    const user = useSelector((state) => state.user.data);
    const metaDataKeys = Object.keys(load.displayMetadata);
    const emailAddress = load.brokerInfo?.contactEmail;
    const mailtoLink = useEmailContent({ emailAddress, load, user });

    return (
        <div className="h-[161px] w-full bg-cm-p-surface rounded-lg gap-1 flex flex-col p-4 pb-[6px]">
            <LoadboardLabel text="Broker info" />
            <div className="w-full mt-1 flex flex-row gap-4 items-center">
                {load.brokerInfo?.name ? <LoadboardValue>{load.brokerInfo?.name}</LoadboardValue> : null}
                {load.brokerInfo?.contactPhone ? (
                    <>
                        <a
                            className="font-medium text-xs/[19px] text-cm-p-accent inline-flex gap-2 items-center"
                            href={`tel:${load.brokerInfo.contactPhone}`}
                        >
                            <PhoneCall className="w-4" />
                            Call
                        </a>
                        {load.brokerInfo.contactEmail ? <div className="h-4 w-[1.5px] bg-cm-p-outline rounded" /> : null}
                    </>
                ) : null}
                {emailAddress && mailtoLink ? (
                    <a className="font-medium text-xs/[19px] text-cm-p-accent inline-flex gap-2 items-center" href={mailtoLink}>
                        <Mail className="w-4" />
                        Email
                    </a>
                ) : null}
            </div>
            <div className="text-xs/[19px] text-cm-p-text-secondary font-medium mb-3">MC {load.brokerInfo.mcNumber}</div>
            <div className="flex flex-col gap-1 justify-center">
                {!load.notes && !metaDataKeys.length ? (
                    <div className="text-cm-p-text-secondary text-xs/[19px] font-normal">
                        <TranslatedText>Broker did not provide any additional note</TranslatedText>
                    </div>
                ) : (
                    <div
                        className={cn(
                            "text-cm-p-text-primary text-xs/[19px] italic max-h-[60px] overflow-y-auto",
                            "[scrollbar-width:thin] [scrollbar-color:var(--cm-p-surface-container-hover)_var(--cm-p-surface-hover)]",
                            "[&::-webkit-scrollbar]:w-[4px]",
                            "[&::-webkit-scrollbar-track]:bg-cm-p-surface-hover [&::-webkit-scrollbar-track]:rounded-[30px]",
                            "[&::-webkit-scrollbar-thumb]:bg-cm-p-surface-container-hover [&::-webkit-scrollbar-thumb]:rounded-[30px]"
                        )}
                    >
                        {load.notes ? load.notes.toString() : null}
                        {metaDataKeys.length
                            ? metaDataKeys.map((key, index) => (
                                  <div key={index}>
                                      {key}: {load.displayMetadata[key] || "- "}
                                  </div>
                              ))
                            : null}
                    </div>
                )}
            </div>
        </div>
    );
};
